import React from 'react';
import { X } from 'lucide-react';
import { ProjectTypeWizard } from './ProjectTypeWizard';
import { ProjectPlanningCategory } from '../types';

interface CreateProjectModalProps {
  onClose: () => void;
}

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({ onClose }) => {
  const handleProjectCreated = (config: {
    selectedType: ProjectPlanningCategory;
    configuration: Record<string, any>;
    metadata: Record<string, any>;
  }) => {
    // Hier könnten wir das Projekt tatsächlich erstellen
    console.log('Projekt-Konfiguration:', config);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-2xl font-bold text-gray-900">🎯 Neues Projekt erstellen</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="p-6">
          <div className="mb-6">
            <p className="text-gray-600">
              Verwenden Sie den intelligenten Projekt-Assistenten, um Ihr Projekt basierend auf
              modernen Rückwärtsplanungsmethoden zu strukturieren.
            </p>
          </div>

          <ProjectTypeWizard
            onComplete={handleProjectCreated}
            onCancel={handleCancel}
            isOpen={true}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateProjectModal;
